/* global modForm */
import { trackFormSubmissionFlow } from '../../helpers';
/**
 * Replacing recaptcha & g-recaptcha-response params with recaptchaCompleted flag
 * @param {Object} formData - Object of form data
 * @returns {Object} Processed formData
 */
export function swapRecaptchaTokenWithFlag(formData) {
	if (!formData) {
		trackFormSubmissionFlow({ noFormDataExitingSwapRecaptchaTokenWithFlag: true });
		return;
	}

	const hasRecaptchaToken = 'recaptcha' in formData && formData.recaptcha !== '';
	const hasGreCaptchaResponseToken = 'g-recaptcha-response' in formData && formData['g-recaptcha-response'] !== '';

	if (hasRecaptchaToken || hasGreCaptchaResponseToken) {
		trackFormSubmissionFlow({ inSwapRecaptchaTokenWithFlag: true });
		formData.recaptchaCompleted = true;
		
		if (!modForm.opts.isModernize) {
			formData.IsRealValidationEnabled = true;
		}
		
		delete formData.recaptcha;
		delete formData['g-recaptcha-response'];
	}

	return formData;
}
